import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const KnowHowUserManuals = () => {
	return <PlaceholderView pageType={PageType.KnowHowUserManuals} text="User manuals" />;
};

export default KnowHowUserManuals;
